import { withFilterFieldBase } from './withFilterFieldBase';
import type { SharedFilterFieldProps } from './types';

const DateSingleFilterFieldContent = ({
  filter,
  state,
  inputClassName,
  filtersDisabled,
  updateFilterState,
}: SharedFilterFieldProps) => {
  return (
    <input
      className={inputClassName}
      type="date"
      value={state?.inputValue ?? ''}
      disabled={filtersDisabled}
      onChange={event => {
        const value = event.target.value;
        updateFilterState(filter.id, current => ({
          ...current,
          inputValue: value,
          displayValue: value,
          touched: true,
        }));
      }}
    />
  );
};

export const DateSingleFilterField = withFilterFieldBase(DateSingleFilterFieldContent, props => ({
  label: props.label,
  showGuidedText: props.showGuidedText,
  guidedText: props.filter.guidedText,
}));
